<template>
<div class="page page">

	<maincontent>
		<template v-slot:content>
			<course :id="id"/>
		</template>
	</maincontent>

</div>
</template>

<style scoped lang="sass">

</style>

<script>
import course from "@/components/modules/courses/course/index.vue";



export default {
	name: 'course_page',
	components: {
        course
	},

	computed: {
        id : function(){
            return this.$route.params.id
        }
	},

	methods: {

	},

	mounted() {

	}
}
</script>
